import React, { useContext } from 'react';
import { AuthContext } from '../../../context/auth';
import Header from '../../../components/Header'
import Ingenieria from '../Ingieneria';
import TablaObras from '../../../components/ingenieriamunicipal/tablaObrasAsignadas';
import Footer from '../../../components/Footer';


function ObrasAsignadas({ setTabla }) {

  const { user } = useContext(AuthContext);
  let op = require('../../../modulos/datos');

  return (

    user && (

      <div className='col-md-12'>
        <header className="col-10 mx-auto m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant">
          <h3 className="fw-bold m-0">
            Asignación de Obras
          </h3>
          <a type="button" onClick={() => setTabla(0)} className="text-light fw-bold fs-6">
            Salir <i className="fas fa-times ms-2"></i>
          </a>
        </header>



        <TablaObras tipo={"obras"}/>

        <div className="col-md-12" style={{ height: "5%", padding: 0 }}>
          <Footer />
        </div>
      </div>
    )


  );
}


export default ObrasAsignadas;
